import { Dispatch, SetStateAction, useState, VFC } from 'react'
import { CheckboxDiv } from 'src/elements/Checkbox'
import { MasterData } from 'src/models/MasterData'
import { black, contributionGray, _profilegreen } from 'src/styles/colors'
import styled, { css } from 'styled-components'
export const SearchCheckbox: VFC<{
  title: string
  items?: MasterData[]
  selectedItems: string[]
  setSelectedItems: Dispatch<SetStateAction<string[]>>
}> = ({ title, items, selectedItems, setSelectedItems }) => {
  const [opened, setOpened] = useState(true)
  const onChangeItems = (value: string, checked: boolean) => {
    if (checked) setSelectedItems([...selectedItems, value])
    else setSelectedItems(selectedItems.filter((item) => value !== item))
  }
  const onClearItems = () => {
    setSelectedItems([])
  }
  return (
    <SearchCheckboxContent>
      <SearchCheckboxHeader>
        <SearchCheckboxTitle opened={opened} onClick={() => setOpened(!opened)}>
          <label />
          {title}
        </SearchCheckboxTitle>
        {opened && selectedItems.length > 0 && (
          <SearchCheckboxClear onClick={() => onClearItems()}>
            選択を解除する
          </SearchCheckboxClear>
        )}
      </SearchCheckboxHeader>
      <Accordion opened={opened}>
        <SearchCheckboxItems>
          {items &&
            items.map((item) => {
              const checked = selectedItems.some((si) => item.value === si)
              return (
                <SearchCheckboxDiv key={`${item.value}_${item.label}`}>
                  <CheckboxDiv color={_profilegreen}>
                    <label>
                      <input
                        id={item.value}
                        type="checkbox"
                        onChange={({ target: { checked } }) =>
                          onChangeItems(item.value, checked)
                        }
                        checked={checked}
                      />
                      <SearchCheckboxInput>{item.label}</SearchCheckboxInput>
                    </label>
                  </CheckboxDiv>
                </SearchCheckboxDiv>
              )
            })}
        </SearchCheckboxItems>
      </Accordion>
    </SearchCheckboxContent>
  )
}

const SearchCheckboxContent = styled.div`
  background: white;
  border-radius: 8px;
  margin: 10px 0px;
`
const SearchCheckboxHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16.8px;
`

const SearchCheckboxClear = styled.div`
  margin-left: 8px;
  display: inline-block;
  font-size: 10px;
  font-weight: 400;
  color: ${contributionGray};
  text-decoration: underline;
  cursor: pointer;
`

const transitionTime = '0.2s'

const SearchCheckboxTitle = styled.div<{ opened: boolean }>`
  cursor: pointer;
  label {
    margin-left: 3px;
    margin-right: 12px;
  }
  label::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    border-top: 6px solid ${black};
    border-right: 6px solid ${black};
    border-bottom: 6px solid transparent;
    border-left: 6px solid transparent;
    transform: rotate(45deg);
    transition: ${transitionTime};
    pointer-events: none;
  }
  ${({ opened }) =>
    opened &&
    css`
      label::before {
        transform: rotate(135deg);
      }
    `}
`

const Accordion = styled.div<{ opened: boolean }>`
  transition: ${transitionTime};
  ${({ opened }) =>
    opened
      ? css`
          max-height: 500px;
          visibility: visible;
        `
      : css`
          max-height: 0px;
          visibility: hidden;
        `}
`

const SearchCheckboxItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0px 40px;
`
const SearchCheckboxDiv = styled.div`
  margin: 0px 8px;
`
const SearchCheckboxInput = styled.span`
  margin-left: 11px;
  cursor: pointer;
`
